import React, { Component } from 'react';
import { connect } from 'react-redux';

import { saveDisplayAnnotationColorChange } from 'PipeRouter';
import FilterHighlightOptionsViews from './views';


class FilterHighlightOptions extends Component {
  constructor(props) {
    super(props);
  }

  onDisplayAnnotationColorChange = event => {
    const { displayAnnotationColors, saveDisplayAnnotationColorChange } = this.props;
    const { id, checked } = event.target;
    let updateDisplayColors = [];

    for (const color of displayAnnotationColors) {
      if (color.markerId === id) {
        color.display = checked;
      }

      updateDisplayColors.push(color);
    }

    saveDisplayAnnotationColorChange(updateDisplayColors);
  }

  render() {
    const viewProps = {
      displayAnnotationColors: this.props.displayAnnotationColors,
      onDisplayAnnotationColorChange: this.onDisplayAnnotationColorChange
    };

    return <FilterHighlightOptionsViews { ...viewProps } />
  }
}

function mapStateToProps(state) {
  const { notebook:{ displayAnnotationColors }} = state;
  return { displayAnnotationColors };
}


export default connect(mapStateToProps, {
  saveDisplayAnnotationColorChange
})(FilterHighlightOptions);
